// hooks
import { useDataTransferContext } from "components/Dashboard/DoctorDashboard/views/data-transfer/contexts/DataTransferContext";
// styles
import styles from "./styles.module.scss";
// components
import UploadTaskUI from "../upload-task-ui";
/**
 * renders the UI for viewing uploaded tasks in modal
 */
const UploadTasks = () => {
  const { uploadTaskStates, onAbort, onSubmitPassword } =
    useDataTransferContext();

  return (
    <div className={styles["upload-tasks"]}>
      {uploadTaskStates.map((el) => (
        <UploadTaskUI
          key={el.id}
          value={el}
          onAbort={onAbort}
          onSubmitPassword={onSubmitPassword}
        />
      ))}
    </div>
  );
};

export default UploadTasks;
